<div
  class="w-full border-separate"
  style="border-spacing: 0"
  role="table"
  aria-busy="true"
  aria-label="Loading table data"
>
  <!-- Header Skeleton -->
  <div *ngIf="showHeader" role="row" class="flex py-3 bg-base border-b border-gray-200">
    <div
      *ngFor="let col of columnArray; let i = index"
      [class]="'px-6 flex items-center ' + getColumnWidth(i) + ' ' + getColumnAlign(i)"
      role="columnheader"
    >
      <!-- Show shimmer placeholder for header -->
      <div class="h-3 skeleton-shimmer-dark rounded" [style.width.%]="getHeaderSkeletonWidth(i)"></div>
    </div>
  </div>

  <!-- Body Skeleton Rows -->
  <div
    *ngFor="let row of rowArray; let rowIndex = index"
    role="row"
    class="flex py-4 bg-base border-b border-gray-200"
    [class.bg-gray-50]="banding && rowIndex % 2 === 1"
  >
    <div
      *ngFor="let col of columnArray; let colIndex = index"
      [class]="'px-6 flex items-center ' + getColumnWidth(colIndex) + ' ' + getColumnAlign(colIndex)"
      role="cell"
    >
      <!-- Text with Subtitle (e.g., Title + ID) -->
      <div *ngIf="shouldShowSubtitle(colIndex)" class="w-full">
        <div class="h-4 skeleton-shimmer rounded mb-1.5" [style.width.%]="getSkeletonWidth(rowIndex, colIndex)"></div>
        <div class="h-3 skeleton-shimmer rounded" [style.width.%]="60"></div>
      </div>

      <!-- Badge (e.g., Status) -->
      <div *ngIf="shouldShowBadge(colIndex)" class="flex items-center gap-2">
        <div class="h-2 w-2 skeleton-shimmer rounded-full"></div>
        <div class="h-3 skeleton-shimmer rounded" [style.width.px]="50"></div>
      </div>

      <!-- Progress (e.g., No. of warranties) -->
      <div *ngIf="shouldShowProgress(colIndex)" class="w-full flex items-center gap-2">
        <div class="h-4 skeleton-shimmer rounded" [style.width.px]="20"></div>
        <div class="h-2 skeleton-shimmer rounded flex-1" [style.width.%]="70"></div>
      </div>

      <!-- Icon/Action -->
      <div *ngIf="shouldShowIcon(colIndex)" class="flex items-center justify-center">
        <div class="h-5 w-5 skeleton-shimmer rounded"></div>
      </div>

      <!-- Date -->
      <div *ngIf="shouldShowDate(colIndex)">
        <div class="h-4 skeleton-shimmer rounded" [style.width.px]="80"></div>
      </div>

      <!-- Default Text -->
      <div
        *ngIf="
          !shouldShowSubtitle(colIndex) &&
          !shouldShowBadge(colIndex) &&
          !shouldShowProgress(colIndex) &&
          !shouldShowIcon(colIndex) &&
          !shouldShowDate(colIndex)
        "
        class="h-4 skeleton-shimmer rounded"
        [style.width.%]="getSkeletonWidth(rowIndex, colIndex)"
      ></div>
    </div>
  </div>
</div>
